if (!customElements.get("button-top")) {
  customElements.define(
    "button-top",
    class ButtonScrollTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector(".button-top");

        if (!this.button) {
          return;
        }

        this.scrollFrame = null;
        this.handleScroll = () => {
          if (this.scrollFrame !== null) return;

          this.scrollFrame = window.requestAnimationFrame(() => {
            this.syncVisibility();
            this.scrollFrame = null;
          });
        };

        window.addEventListener("scroll", this.handleScroll, { passive: true });
        this.button.addEventListener("click", () => this.scrollToTop());
        this.syncVisibility();
      }

      syncVisibility() {
        const shouldShow = window.scrollY > 0;
        this.button.hidden = !shouldShow;
        this.button.classList.toggle("button-top-visible", shouldShow);
      }

      scrollToTop() {
        const reduceMotion =
          typeof window.matchMedia === "function" &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        document.documentElement.scrollTo({
          top: 0,
          behavior: reduceMotion ? "auto" : "smooth",
        });
      }
    },
  );
}
